import { DATE_FORMAT_YYYY_MM_DD } from "../constants/DateConstant";
import _ from "lodash";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

export const getFilteredOrders = (orders, dateRange, selectedRows) => {
  let filteredOrders = selectedRows;
  // If orderStatusFilter = PAID -> Get only paid orders
  // If not -> Get all orders except those with CREATED status
  if (!!dateRange && dateRange.length > 0) {
    filteredOrders = filterOrdersDateRange(orders, dateRange);
  }

  // Order by date ascending
  return _.orderBy(filteredOrders, ["orderDateTime"], ["asc"]);
};

export const filterOrdersDateRange = (orders, dateRange) => {
  let startDate = dateRange[0].format(DATE_FORMAT_YYYY_MM_DD);
  let endDate = dateRange[1].format(DATE_FORMAT_YYYY_MM_DD);
  return _.filter(orders, function (order) {
    return dayjs(order.farmorderDeliveryDate).isBetween(startDate, endDate, undefined, "[]");
  });
};

export const getFilteredOrdersDeliveryDate = (orders, dateRange, selectedRows) => {
  if (selectedRows?.length > 0) {
    return selectedRows;
  }

  let filteredOrders = selectedRows;
  if (!!dateRange && dateRange.length > 0) {
    filteredOrders = filterOrdersByDeliveryDateDateRange(orders, dateRange);
  }

  // Order by date ascending
  return _.orderBy(filteredOrders, ["orderDateTime"], ["asc"]);
};

export const filterOrdersByDeliveryDateDateRange = (orders, dateRange) => {
  let startDate = dateRange[0].format(DATE_FORMAT_YYYY_MM_DD);
  let endDate = dateRange[1].format(DATE_FORMAT_YYYY_MM_DD);
  return _.filter(orders, function (order) {
    return dayjs(order.farmorderDeliveryDate).isBetween(startDate, endDate, undefined, "[]");
  });
};
